import { Status, useFetchRefactored } from 'civic-champs-shared/api/hooks'
import { useCallback } from 'react'
import { FeatureSet, FeatureType } from '../types'

const useGetFeatureSet = (): [
  (organizationId: number, type?: FeatureType) => Promise<FeatureSet>,
  Status<FeatureSet>,
] => {
  const [request, status] = useFetchRefactored<FeatureSet>()
  const getFeaturesForOrg = useCallback(
    async (organizationId, type?: FeatureType) => {
      return request({
        method: 'get',
        url: `/organizations/${organizationId}/features`,
        config: type ? { queryStringParameters: { type } } : undefined,
      })
    },
    [request],
  )

  return [getFeaturesForOrg, status]
}

export default useGetFeatureSet
